.root {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}
.item {
  position: relative;
  display: inline-flex;
  width: 2.75rem;
  height: 2.75rem;
}
.item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.check {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 2px;
  box-sizing: content-box;
  border-radius: 50%;
  color: var(--color-on-accent);
  background: var(--color-accent);
}
